<template>
    <rkm-data-table
        :fields="fields"
        :repository="repositories.vacina"
        ref="RkmDataTable"
        sort-by="nome"
    >
        <template v-slot:cell(actions)="row">
            <rkm-button
                @click="handleEdit(row.item.id)"
                authorize="update-cadastro-vacina"
                color="primary"
                small
                title="Editar"
            >
                <rkm-icon icon="pen" />
            </rkm-button>

            <rkm-button
                :disabled="!!row.item.codigo"
                @click.stop="handleDestroy(row.item.id)"
                authorize="destroy-cadastro-vacina"
                color="danger"
                small
                title="Excluir"
            >
                <rkm-icon icon="trash" />
            </rkm-button>
        </template>
    </rkm-data-table>
</template>

<script>
// Mixins.
import { error, repository } from '@/mixins'

export default {
    computed: {
        fields() {
            return [
                {
                    key: 'nome',
                    label: 'Nome',
                    name: 'cadastroVacina.nome',
                    searchable: true,
                    sortable: true,
                },
                {
                    key: 'abreviacao',
                    label: 'Abreviação',
                    name: 'cadastroVacina.abreviacao',
                    searchable: true,
                    sortable: true,
                },
                {
                    key: 'sigla',
                    label: 'Sigla',
                    name: 'cadastroVacina.sigla',
                    searchable: true,
                    sortable: true,
                },
                {
                    key: 'calendario',
                    label: 'Calendário',
                    name: 'cadastroVacina.calendario',
                    searchable: true,
                    sortable: true,
                },
                {
                    class: 'col-min text-center',
                    key: 'actions',
                    label: 'Ações',
                },
            ]
        },
    },
    created() {
        this.repositories = {
            vacina: this.getConectaSusRepository('cadastro.vacina')
        }
    },
    methods: {
        handleEdit(id) {
            this.$router.push({ name: 'cadastro-vacina-edit', params: { id: id } })
        },
        handleDestroy(id) {
            const destroy = () => this.repositories.vacina.destroy(id)
                .then(() => this.$refs.RkmDataTable.refresh())

            this.showDeleteConfirmation('Deseja realmente excluir a vacina?', destroy, this.handleError)
        },
    },
    mixins: [ error, repository ],
}
</script>